import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { SearchIcon } from "../../../../assets/icons/svgicons";
import { ROUTES } from "../../../../routes";
import Card from "../../../common/Card/Card";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import styles from "./Orders.module.scss";

export const getType = (type) => {
  switch (type) {
    case "BUY":
      return "secondary";
    case "SELL":
      return "orange";
    case "MARKET":
    case "REDEEM":
    case "CONVERT":
      return "primary";
    default:
      return undefined;
  }
};

const Orders = () => {
  const [search, setSearch] = useState("");

  return (
    <>
      <Card
        title={
          <>
            <span className="d-md-inline d-none">My</span> Orders
          </>
        }
        className={styles.transactions}
        bodyClassName={styles.body}
        headerClassName={styles.headerCard}
        headerContent={
          <>
            <InputFormik
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              icon={<SearchIcon />}
              placeholder="Search by Order ID..."
              iconClassName={styles.search_icon}
              className={styles.search_input}
            />
            <div className={`${styles.tabs} ${styles.tabsNew}`}>
              <NavLink
                onClick={() => setSearch("")}
                to={ROUTES.ORDERS_OPENED}
              >
                Open
              </NavLink>
              <NavLink
                onClick={() => setSearch("")}
                to={ROUTES.ORDERS_COMPLETED}
              >
                Complete <span className={styles.d_text}>d</span>
              </NavLink>
            </div>
          </>
        }
      >
        <Outlet context={search} />
      </Card>
    </>
  );
};

export default Orders;
